import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@repo/videa-components/src/index';
import { cn } from '@repo/videa-components/src/lib/utils';
import { CommandItem } from '@repo/videa-components/src/ui/command';

import type {
  ZuubOnboardingStatusResponse,
  ZuubPayer,
} from '@/@types/zuub/contracts';

import { PayerAvatar } from '../../PayerAvatar';

import { PayerActionsMenu } from './PayerActionsMenu';
import { PayerStatusChip } from './PayerStatusChip';

interface PayerListItemProps {
  payer: ZuubPayer;
  isSelected: boolean;
  payerStatus?: ZuubOnboardingStatusResponse;
  isActivelyTesting: boolean;
  isLoading: boolean;
  onSelect: () => void;
  onGoToPortal: (portalUrl: string | undefined) => void;
}

export const PayerListItem = ({
  payer,
  isSelected,
  payerStatus,
  isActivelyTesting,
  isLoading,
  onSelect,
  onGoToPortal,
}: PayerListItemProps) => {
  return (
    <CommandItem
      onSelect={onSelect}
      value={payer.id.toString()}
      className={cn(
        'vai-flex vai-items-center vai-gap-4 vai-px-4 vai-py-3 vai-cursor-pointer',
        isSelected && 'vai-bg-blue-50 vai-border-l-4 vai-border-l-blue-600',
      )}
    >
      <PayerAvatar payer={payer} size="sm" />
      <div className="vai-flex-1 vai-min-w-0">
        <Tooltip>
          <TooltipTrigger asChild>
            <div className="vai-text-base vai-font-medium vai-text-gray-900 vai-truncate">
              {payer.name}
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>{payer.name}</p>
          </TooltipContent>
        </Tooltip>
      </div>
      <div className="vai-flex vai-items-center vai-gap-2 vai-flex-shrink-0">
        <PayerStatusChip
          payerStatus={payerStatus}
          isActivelyTesting={isActivelyTesting}
          isLoading={isLoading}
        />
        {/* Disabled until we have more options to display */}
        {/* <PayerActionsMenu
          portalUrl={payer.portalUrl}
          onGoToPortal={onGoToPortal}
        /> */}
      </div>
    </CommandItem>
  );
};
